import { render } from "./IconSignatureColored.vue?vue&type=template&id=3ff63836"
import script from "./IconSignatureColored.vue?vue&type=script&lang=js"
export * from "./IconSignatureColored.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__